export const setTabulationGallery = (data) => {
  return {
    type: 'SET_TABULATION_GALLERY',
    payload: { data },
  }
}
